// extracted by mini-css-extract-plugin
module.exports = {"TicketColumns":"TicketColumns_TicketColumns__2QoxP","slide-in-right":"TicketColumns_slide-in-right__RcolQ","slide-out-right":"TicketColumns_slide-out-right__20Dnx"};